import { app } from '../../../../app';
import { Controller } from './slack-verification.controller';

app.component('slackVerification', {
    controller: Controller,
    templateUrl: require('./slack-verification.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/public/verification/slack/slack-verification.component.js